module.exports = __webpack_public_path__ + "img/banner01.5fd0b8a3.webp";